import Vue from "vue";
import {Component, Watch} from "vue-property-decorator";
import "./automationDetails.styl";
import {Automation, AutomationInt} from "../../../models/automation";
import {ConfigService} from "../../../helpers/services/configService";
import {RouterManager, Routes} from "../../../router";
import {eventBus, signalNames} from "../../../bus";
import {application} from "../../../stores/application";
const template = require("./automationDetails.vue");

@Component({
  template: template
})
export class AutomationDetailsComponent extends Vue {

  automation: AutomationInt = null;
  position: String = null;
  loading: boolean = false;
  loading1: boolean = false;
  loading2: boolean = false;
  checkType: string = null;
  response: any = null;
  invitedList: boolean = false;
  automationStatus: string = "Offline";

  created(): void {
    this.refreshAutomation();
  }

  invitedListCheck() {
    console.log("AUTOMATION:", this.automation);
    if (this.automation.users_invited_list) {
      console.log("LIST:", this.automation.users_invited_list.length );
      if (this.automation.users_invited_list.length > 0) {
        this.invitedList = true;
      } else {
        this.invitedList = false;
      }
    } else {
      this.invitedList = false;
    }
  }
  refreshAutomation() {
    this.automation = null;
    application.commitStartLoader(this.$store);
    Vue.http.get(ConfigService.automations + "/" + this.$route.params.id, {})
      .then(response => {
        console.log("RESPONSE:", response);
        this.automation = new Automation().deserialize(response.data.data).flatten();
        eventBus.$emit(signalNames.setToolbarOptions, {
          title: "Automation: \" " + this.automation.automation_name + " \" ",
          // backAction: () => RouterManager.instance.router.push(Routes.automations),
          backAction: () => RouterManager.instance.router.go(-1),
          reloadAction: () => this.refreshAutomation()
        });
        console.log("Automation:", this.automation);
        Vue.http.get(ConfigService.apiEndpoint1 + ConfigService.automations1 + "/" + this.automation.uuid, {})
          .then(response => {
            // console.log("dispacher:", response);
            this.automation.automation_firmware = response.body.firmware;
          })
          .then(response => {
            Vue.http.get(ConfigService.apiEndpoint1 + ConfigService.automations1 + "/" + this.automation.uuid + "/online", {}).then((response) => {
              this.automationStatus = response.status;
              // console.log("Automation status:", this.automationStatus);
            }).catch(response => {
              // console.log("error: ", response.status);
              if (response.status === 404 || response.status === 200) {
                this.automationStatus = response.status;
              } else {
                eventBus.$emit(signalNames.showError, "Stato automazione non rilevabile!");
              }
              // console.log("Automation status:", this.automationStatus);
              application.commitStopLoader(this.$store);

            });
          });
        this.getLocation();
        this.invitedListCheck();
        application.commitStopLoader(this.$store);
      })
      .catch(error => {
        application.commitStopLoader(this.$store);
        eventBus.$emit(signalNames.showError);
      });
  }

  getLocation() {
    if (this.automation.latitude && this.automation.longitude) {
      Vue.http.get("https://maps.googleapis.com/maps/api/geocode/json?latlng=" + this.automation.latitude + "," + this.automation.longitude + "&sensor=true")
        .then(response => this.position = response.body.results[0].formatted_address)
        .catch(error => eventBus.$emit(signalNames.showError));
    }
  }
  handleEpromClick() {
    this.loading = true;
    Vue.http.get(ConfigService.apiEndpoint1 + ConfigService.automations1 + "/" + this.automation.uuid + "/execute/eeprom", {})
      .then(response => {
        console.log("eeprom", response);
        this.response = response.body;
        this.checkType = "eeprom";
        this.loading = false;
      })
      .catch(error => {
        this.loading = false;
        eventBus.$emit(signalNames.showError);
      });
  }
  handleStatusClick() {
    this.loading1 = true;
    Vue.http.get(ConfigService.apiEndpoint1 + ConfigService.automations1 + "/" + this.automation.uuid + "/execute/diagnosis", {})
      .then(response => {
        console.log("status", response);
        this.response = response.body;
        this.checkType = "status";
        this.loading1 = false;
      })
      .catch(error => {
        this.loading1 = false;
        eventBus.$emit(signalNames.showError);
      });
  }
  handleDeleteClick() {
    this.loading2 = true;
    Vue.http.delete(ConfigService.automations + "/" + this.automation.id + "", {})
      .then(response => {
        console.log("automation delete", response);
        this.response = response.body;
        this.loading2 = false;
        Vue.http.delete(ConfigService.apiEndpoint1 + ConfigService.automations1 + "/" + this.automation.uuid + "", {})
          .then(response => {
            console.log("automation delete", response);
            this.response = response.body;
            this.loading2 = false;
            RouterManager.instance.router.push(Routes.automations);
          })
          .catch(error => {
            this.loading2 = false;
            eventBus.$emit(signalNames.showError);
            RouterManager.instance.router.push(Routes.automations);
            throw error;
          });
      })
      .catch(error => {
        this.loading2 = false;
        eventBus.$emit(signalNames.showError);
      });
  }

}

Vue.component("cmAutomationDetails", AutomationDetailsComponent);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/plain/automationDetails/automationDetails.ts